import React from "react";
import Modal from "@mui/material/Modal";
import MDBox from "mui_components/MDBox";
import MDTypography from "mui_components/MDTypography";
import MDButton from "mui_components/MDButton";
import brandColor from "assets/images/logo.png";

export const announcementConfig = {
  // 1 = show popup after successful login, 0 = disabled
  active: 1,
  source: "Announcement from Penang Port",
  title: "Important Notice",
  message: `The Port Pass Office has ceased operations effective 20 March 2026. For matters related to digital port pass applications or any enquiries, please proceed to Balai Polis Pelabuhan Butterworth or Balai Polis Pelabuhan Pulau Pinang, or contact the Port Pass Supervisor at 04-3737183.`,
};

export function AnnouncementModal({ open, onClose }) {
  const handleModalClose = (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      disableEscapeKeyDown
      aria-labelledby="post-login-announcement-title"
      aria-describedby="post-login-announcement-message"
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(15, 23, 42, 0.55)",
          },
        },
      }}
    >
      <MDBox
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "92%", sm: "84%", md: 760 },
          maxHeight: "88vh",
          overflowY: "auto",
          borderRadius: "16px",
          bgcolor: "#ffffff",
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 },
          outline: "none",
        }}
      >
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="primary"
            p={1.5}
            sx={{ width: "100%" }}
          >
            <MDBox
              mx="auto"
              p={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
            >
              <MDBox component="img" src={brandColor} alt="Brand" width="80%" />
              <MDTypography
                variant="h6"
                fontWeight="medium"
                color="light"
                mt={1}
                mr={5}
                alignSelf="end"
              >
                Digital Portpass
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>

        <MDBox
          sx={{
            mt: 2,
            p: { xs: 2, sm: 2.5 },
            borderRadius: "12px",
            background: "linear-gradient(135deg, #e9f5ff 0%, #f3f8ff 100%)",
            border: "1px solid #d7e7ff",
          }}
        >
          <MDTypography variant="overline" fontWeight="bold" color="info">
            {announcementConfig?.source || "Announcement"}
          </MDTypography>
          <MDTypography id="post-login-announcement-title" variant="h4" mt={0.5} mb={2}>
            {announcementConfig?.title || "Important Notice"}
          </MDTypography>
          <MDTypography
            id="post-login-announcement-message"
            variant="body1"
            color="text"
            sx={{ whiteSpace: "pre-line", lineHeight: 1.8 }}
          >
            {announcementConfig?.message || ""}
          </MDTypography>
        </MDBox>

        <MDBox mt={3} display="flex" justifyContent="flex-end">
          <MDButton variant="gradient" color="info" onClick={onClose}>
            Close
          </MDButton>
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default announcementConfig;
